<script>
	export let videos;
	export let title;
	export let anchor;
	export let largeVideos;
</script>

<div class="container" id="{anchor}">
	<h1>{title}</h1>
	<div class="video-container {largeVideos === "large" ? "video-size-large" : "video-size-small"}">
		{#each videos as video}
			<div class="video-item">
				<iframe
					class="video"
					width="560"
					height="315"
					src="https://www.youtube.com/embed/{video.id}"
					title="YouTube video player"
					frameborder="0"
					allow="autoplay; clipboard-write; encrypted-media;"
					allowfullscreen
				/>
				<p class="video-title">{video.title}</p>
			</div>
		{/each}
	</div>
</div>

<style>
	.video-size-large {
		--video-width: 1000px;
	}

	.video-size-small {
		--video-width: 500px;
	}

	.container {
		scroll-margin-top: 100px;
		display: flex;
		flex-direction: column;
		padding-top: 50px;
		background: var(--secondary-bg-color);
		color: var(--primary-bg-color);
		text-align: center;
		align-items: center;
	}

	.video-container {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: center;
		max-width: 2000px;
	}

	.video {
		width: var(--video-width);
		height: calc(var(--video-width) * 0.5625);
		background: var(--secondary-bg-color);
	}

	.video-item {
		width: var(--video-width);
		margin: 25px;
	}
	
	.video-title {
		margin-top: 2px;
		margin-bottom: 25px;
		font-size: 18px;
		width: 100%;
	}

	@media only screen and (max-width: 920px) {
		.video {
			--video-width: 720px;
		}
	}

	@media only screen and (max-width: 720px) {
		.video {
			--video-width: 400px;
		}
	}
</style>
